/* 路过图床
const groupMembers = [
    { "Id":1,
        "Name":"集团大楼",
        "Title":"初印象",
        "Path":"/goto",
        "Img":"https://s2.ax1x.com/2019/08/21/mthVPS.jpg" },
    { "Id":2,
        "Name":"海一电子",
        "Title":"岗位",
        "Path":"/recruitment",
        "Img":"https://s2.ax1x.com/2019/08/21/mthFVP.jpg" },
    { "Id":3,
        "Name":"中雅科技",
        "Title":"校招日历",
        "Path":"/campus",
        "Img":"https://s2.ax1x.com/2019/08/21/mthkUf.jpg" },
    { "Id":4,
        "Name":"宁夏海力",
        "Title":"企业文化",
        "Path":"/culture",
        "Img":"https://s2.ax1x.com/2019/08/21/mthCDI.jpg" },
    { "Id":5,
        "Name":"联力",
        "Title":"Q&A",
        "Path":"/qa",
        "Img":"https://s2.ax1x.com/2019/08/21/mth9KA.jpg" },
    { "Id":6,
        "Name":"日本",
        "Title":"企业视频",
        "Path":"/video",
        "Img":"https://s2.ax1x.com/2019/08/21/mthSvd.jpg" }
]
*/
/* 阿里云*/
const groupMembers = [
    { "Id":1,
        "Name":"集团大楼",
        "Title":"初印象",
        "Path":"/goto",
        // "Img":"https://histar.oss-cn-shanghai.aliyuncs.com/%E6%B5%B7%E6%98%9F%E6%8B%9B%E8%81%98%E5%9B%BE%E7%89%87/%E9%9B%86%E5%9B%A2%E5%A4%A7%E6%A5%BC.jpg" },
        "Img":"https://histar.oss-cn-shanghai.aliyuncs.com/2022-8-18/2.1_compressed.jpg" },
    // { "Id":2,
    //     "Name":"海一电子",
    //     "Title":"岗位",
    //     "Path":"/recruitment",
    //     // "Img":"https://histar.oss-cn-shanghai.aliyuncs.com/%E6%B5%B7%E6%98%9F%E6%8B%9B%E8%81%98%E5%9B%BE%E7%89%87/%E6%B5%B7%E4%B8%80%E7%94%B5%E5%AD%90.jpg" },
    //     "Img":"https://histar.oss-cn-shanghai.aliyuncs.com/2022-8-18/2.2_compressed.jpg" },
    { "Id":2,
        "Name":"新雅科技",
        "Title":"岗位",
        "Path":"/recruitment",
        // "Img":"https://histar.oss-cn-shanghai.aliyuncs.com/%E6%B5%B7%E6%98%9F%E6%8B%9B%E8%81%98%E5%9B%BE%E7%89%87/%E6%B5%B7%E4%B8%80%E7%94%B5%E5%AD%90.jpg" },
        "Img":"https://histar.oss-cn-shanghai.aliyuncs.com/2025-08-25/%E6%96%B0%E9%9B%85%E7%85%A7%E7%89%87.jpg" },
    { "Id":3,
        "Name":"中雅科技",
        "Title":"校招日历",
        "Path":"/campus",
        "Img":"https://histar.oss-cn-shanghai.aliyuncs.com/%E6%B5%B7%E6%98%9F%E6%8B%9B%E8%81%98%E5%9B%BE%E7%89%87/%E4%B8%AD%E9%9B%85%E7%A7%91%E6%8A%80.jpg" },
    { "Id":4,
        "Name":"宁夏海力",
        "Title":"企业文化",
        "Path":"/culture",
        "Img":"https://histar.oss-cn-shanghai.aliyuncs.com/%E6%B5%B7%E6%98%9F%E6%8B%9B%E8%81%98%E5%9B%BE%E7%89%87/%E5%AE%81%E5%A4%8F%E6%B5%B7%E5%8A%9B.jpg" },
    { "Id":5,
        "Name":"联力",
        "Title":"Q&A",
        "Path":"/qa",
        "Img":"https://histar.oss-cn-shanghai.aliyuncs.com/%E6%B5%B7%E6%98%9F%E6%8B%9B%E8%81%98%E5%9B%BE%E7%89%87/%E8%81%94%E5%8A%9B.jpg" },
    { "Id":6,
        "Name":"日本",
        "Title":"企业视频",
        "Path":"/video",
        "Img":"https://histar.oss-cn-shanghai.aliyuncs.com/%E6%B5%B7%E6%98%9F%E6%8B%9B%E8%81%98%E5%9B%BE%E7%89%87/%E6%97%A5%E6%9C%AC.jpg" }
]

export function getGroupMembers() {
    return groupMembers
}



// WEBPACK FOOTER //
// ./src/mock/home.js